import { render, staticRenderFns } from "./PayFastToUpSuccess.vue?vue&type=template&id=978956fe&scoped=true&"
import script from "./PayFastToUpSuccess.vue?vue&type=script&lang=js&"
export * from "./PayFastToUpSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PayFastToUpSuccess.vue?vue&type=style&index=0&id=978956fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978956fe",
  null
  
)

export default component.exports